import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const P = '/mang-xa-hoi'

// Lọc bài viết
export function locBaiViet(querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${P}/bai-dang`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy chi tiết bài viết
export function layChiTietBaiViet(postId: number) {
  try {
    return axiosApi.get(`${P}/bai-dang/${postId}`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Lấy bài viết của người dùng
export function layBaiVietCuaNguoiDung(userId: number, querySt?: string) {
  try {
    const query = querySt ? queryString.parse(querySt) : {}
    return axiosApi.get(`${P}/nguoi-dung/${userId}/bai-dang`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Tạo bài viết
export function taoBaiViet(params: {
  noiDung: string
  danhSachMention?: number[]
  danhSachDinhKem?: number[]
  trangThai?: string
}) {
  try {
    return axiosApi.post(`${P}/bai-dang`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Cập nhật bài viết
export function capNhatBaiViet(
  postId: number,
  params: {
    noiDung?: string
    danhSachMention?: number[]
    danhSachDinhKem?: number[]
  }
) {
  try {
    return axiosApi.put(`${P}/bai-dang/${postId}`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

// Xóa bài viết
export function xoaBaiViet(postId: number) {
  try {
    return axiosApi.delete(`${P}/bai-dang/${postId}`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
